import React from 'react';
import { Input, Label } from '../Form';
import UserPicker from '../User/UserPicker';
import { DateTimePicker } from '../Date/DateTimePicker';
import FormRow from '../Form/FormRow';
import Form from '../Form/Form';
import FormColumn from '../Form/FormColumn';
import CustomerPicker from '../Customer/CustomerPicker';
import { HazardSurveyInput } from './types';

type HazardSurveyEditFormProps = {
  value: HazardSurveyInput;
  onChange: (hazardSurvey: HazardSurveyInput) => void;
  siteAddressId?: string;
  waterServiceId?: string | null;
};

const HazardSurveyEditForm: React.FC<HazardSurveyEditFormProps> = ({
  onChange,
  value,
  siteAddressId,
  waterServiceId,
}) => {
  return (
    <Form>
      <FormRow>
        <FormColumn>
          <Label htmlFor="assignedToProfileId">Assign to</Label>
          <UserPicker
            autoFocus
            userId={value.outboundAssignment?.vendorProfileId}
            onChange={(user) => {
              onChange({
                ...value,
                outboundAssignment: user
                  ? {
                      ...value.outboundAssignment,
                      vendorProfileId: user.profileId,
                    }
                  : undefined,
              });
            }}
          />
        </FormColumn>
        <FormColumn>
          <Label>Site Contact</Label>
          <CustomerPicker
            customerProfileId={value.contactProfileId}
            serviceAddressId={siteAddressId}
            // waterServiceId={waterServiceId ?? undefined}
            serviceAddressWhere={{
              active: true,
              addressId: siteAddressId,
            }}
            isClearable
            onChange={(customer) =>
              onChange({
                ...value,
                contactProfileId: customer?.profileId,
              })
            }
          />
        </FormColumn>
      </FormRow>
      <FormRow>
        <FormColumn>
          <Label htmlFor="scheduled">Schedule for</Label>
          <DateTimePicker
            selected={value.scheduled ? new Date(value.scheduled) : null}
            onChange={(date: string | null) => {
              onChange({
                ...value,
                scheduled: date,
              });
            }}
          />
        </FormColumn>
      </FormRow>
    </Form>
  );
};

export default HazardSurveyEditForm;
